import React from "react";
import { useTranslation } from "react-i18next";
import PageHero from "../components/PageHero";
import { Kicker, Reveal } from "../components/motion";

const IMG = "https://static.prod-images.emergentagent.com/jobs/60fe7cfd-579c-48af-b4a9-bdfd3f1b809e/images/30e0299e9eca797787de29a57773e059f808d7056f12a2c880e2a7620659ff46.png";

export default function About() {
  const { t } = useTranslation();

  return (
    <div data-testid="page-about">
      <PageHero
        testId="about-hero"
        kicker={t("about.kicker")}
        title={t("about.headline")}
        lead={t("about.intro")}
        aside={
          <div className="paper aspect-[4/5] overflow-hidden relative">
            <img src={IMG} alt="Science laboratory" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/50 to-transparent" />
          </div>
        }
      />

      <section className="surface-2 border-b border-line" data-testid="about-mission-vision">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-20 lg:py-28 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Reveal>
            <div className="paper p-10 lg:p-14 h-full" data-testid="about-mission">
              <Kicker>{t("about.mission_label")}</Kicker>
              <p className="font-display text-3xl lg:text-4xl mt-6 leading-tight text-ink">{t("about.mission_body")}</p>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="panel-forest rounded-[14px] p-10 lg:p-14 h-full" data-testid="about-vision">
              <div className="relative">
                <Kicker light>{t("about.vision_label")}</Kicker>
                <p className="font-display text-3xl lg:text-4xl mt-6 leading-tight text-white">{t("about.vision_body")}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="surface-1" data-testid="about-values">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-20 lg:py-28">
          <Reveal>
            <h2 className="font-display text-4xl lg:text-5xl max-w-2xl leading-tight text-ink">{t("about.values_title")}</h2>
          </Reveal>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {["v1", "v2", "v3", "v4"].map((k, i) => (
              <Reveal key={k} delay={i * 0.1}>
                <div className="gxr-card p-8 lg:p-10 h-full" data-testid={`about-value-${k}`}>
                  <div className="font-display text-5xl text-gold leading-none">0{i + 1}</div>
                  <h3 className="font-display text-2xl mt-6 text-ink">{t(`about.values.${k}_t`)}</h3>
                  <p className="mt-3 text-slate leading-relaxed">{t(`about.values.${k}_b`)}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
